import { render, staticRenderFns } from "./SupplyDemandInfo.vue?vue&type=template&id=dcf5c8da"
import script from "./SupplyDemandInfo.vue?vue&type=script&lang=js"
export * from "./SupplyDemandInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports